import React from 'react';
import "./WorkHistory.css";

export default function WorkHistory() {


  return (

    <div>

      <div className="work-history-container mx-2 my-4">
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between">
            <span className="company-name">DKSH CSSC</span>
            <span className="year-passed-out">2020-2021</span>
          </div>
        </div>


        <div className='d-flex flex-column '>
          <span className='position'>
            Intern, Technical Delivery – Mobile Developments
          </span>
          <span className='description-position'>
            <ul>
              <li>
                Implemented a proof of concept (POC) by integrating DevOps into Mobile Development Life Cycle.
              </li>
              <li>
                Hands-on experiences in Micro Focus UFT, Katalon Studio, and automation frameworks such as Appium and Selenium.
              </li>
              <li>
                Set up a staging environment and integration of Jenkins with Katalon Studio on Azure Cloud server.
              </li>
              <li>
                Responsible for writing automation test scripts and creating/updating relevant documentation.
              </li>
            </ul>
          </span>
        </div>


        <div className='d-flex flex-column '>
          <span className='position'>
            Intern, Technical Delivery – Mobile Developments
          </span>
          <span className='description-position'>
            <ul>
              <li>
                Implemented a proof of concept (POC) by integrating DevOps into Mobile Development Life Cycle.
              </li>
              <li>
                Hands-on experiences in Micro Focus UFT, Katalon Studio, and automation frameworks such as Appium and Selenium.
              </li>
              <li>
                Set up a staging environment and integration of Jenkins with Katalon Studio on Azure Cloud server.
              </li>
              <li>
                Responsible for writing automation test scripts and creating/updating relevant documentation.
              </li>
            </ul>
          </span>
        </div>

      </div>
    </div>
  );
}